import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  regionUpdate (params) {
    return axios.post(global.CMC_BASE + '/region/updateRegion', params)
  },
  regionDelete (params) {
    return axios.post(global.CMC_BASE + '/region/deleteRegion', params)
  },
  regionInsert (params) {
    return axios.post(global.CMC_BASE + '/region/insertRegion', params)
  },
  regionFindTree () {
    return axios.post(global.CMC_BASE + '/region/findAllRegion')
  },
  regionFindByCondition (params) {
    return axios.post(global.CMC_BASE + '/region/findByCondition', params)
  },
  // 查找树形结构的区域信息,status=50
  regionFindByStatus (params) {
    return axios.post(global.CMC_BASE + '/region/findAllRegionDesc', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/cmc/region.js